import { Button, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';
import { useNotification } from '@/context/notification';
import { clientKeys } from '@/data/@clients/client-keys';
import { PlanStatus } from '@/data/idp/plans/interfaces';
import { usePlanStatuses } from '@/data/idp/plans/statuses';

interface RestartPlanDialogProps {
  id: string;
  onClose: () => void;
}

export const RestartPlanDialog = ({ id, onClose }: RestartPlanDialogProps) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = usePlanStatuses();
  const { toast } = useNotification();

  const deletePlan = () => {
    mutate(
      { id, status: PlanStatus.InProgress },
      {
        onSuccess: () => {
          queryClient.refetchQueries({
            queryKey: [clientKeys.usePlanShow, id],
          });
          onClose();
        },
        onError: () => {
          toast({
            content:
              'Não foi possível retomar o plano. Tente novamente mais tarde.',
            type: 'error',
          });
        },
      }
    );
  };

  return (
    <BaseDialog
      title="Deseja retomar este plano?"
      onClose={onClose}
      icon={<Icon name="siren-rounded" />}
      actionsComponent={
        <>
          <Button onClick={onClose}>Voltar</Button>
          <Button variant="contained" onClick={deletePlan} loading={isPending}>
            Retomar plano
          </Button>
        </>
      }
    >
      <Typography>
        Depois de iniciado, você vai poder acompanhar e atualizar o progresso
        das atividades. Lembre-se: O plano terá uma nova data de início quando o
        plano volta para “Em andamento”.
      </Typography>
    </BaseDialog>
  );
};
